var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:['toggle-wrapper', { on: _vm.isOn }]},[_c('div',{class:['toggle-indicator', { on: _vm.isOn }]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }